import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { GenericTableComponent } from 'src/app/component/generic-table/generic-table.component';

@Component({
  selector: 'app-fueros',
  standalone: true,
  imports:[GenericTableComponent],
  template: `<app-generic-table [nombreEntidad]="'Fuero'" [nombreEntidadTabla]="'Fueros'" [titulo]="'Fueros'"></app-generic-table>`,
  styleUrl: './fueros.component.css',
  //changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FuerosComponent {


}
